a.fp-link.-no-text-decoration(:href='club.webappUrl' rel='noreferrer')
  .fp-decorated-listing-element
    .fp-decorated-listing-element--logo
      img(:src='club.logoUrl')
    .fp-decorated-listing-element--text
      span.fp-text.-text-md {{ t('linkedClub.interestedBy') }}
      span.fp-text.-text-2xl.-text-semi-bold(:data-test='`linked-club.${club.slug}.name`') {{ t('linkedClub.discover', { club: club.platformName }) }}
    .fp-decorated-listing-element--banner
      img(:src='club.bannerUrl')
